var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "search-item",
            {
              attrs: {
                "config-module": "101402",
                "show-simple": false,
                "expand-adv": true,
                "custom-search-items": _vm.customSearchItems
              },
              on: { advSearchItemCallBack: _vm.toAdvancedQuery }
            },
            [
              _c(
                "template",
                { slot: "searchAreaHeader" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "showEditDialog", type: "primary" },
                      on: { click: _vm.showEditDialog }
                    },
                    [_vm._v(_vm._s(_vm.$t("Partners.openB2BAccount")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "resetUserPwd", type: "primary" },
                      on: { click: _vm.resetUserPwd }
                    },
                    [_vm._v(_vm._s(_vm.$t("Partners.resetPassword")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isTP,
                          expression: "isTP"
                        }
                      ],
                      attrs: {
                        no: "modificationOfBookingAgents",
                        type: "primary"
                      },
                      on: { click: _vm.modificationOfBookingAgents }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("Partners.modificationOfBookingAgents"))
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "goBack", type: "primary" },
                      on: { click: _vm.goBack }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Return")))]
                  )
                ],
                1
              )
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  "config-module": "101403",
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "101403",
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize,
                  total: _vm.total
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: function($event) {
                    return _vm.toAdvancedQuery()
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.$t("Partners.openB2BSettings"),
            width: "400px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            },
            close: _vm.closeEditDialog
          }
        },
        [
          _c(
            "div",
            { staticClass: "app-main-inner-row invite-set-password" },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "70px", "label-position": "top" } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("div", { staticClass: "custom-label-container" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Password")))
                        ]),
                        _vm.hasNewB2B
                          ? _c(
                              "span",
                              { staticClass: "randomClass" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_RandomPassword")
                                    ) +
                                    " "
                                ),
                                _c("el-checkbox", {
                                  attrs: { no: "randomPassword" },
                                  on: { change: _vm.handleCheckRandomPass },
                                  model: {
                                    value: _vm.editDialog.randomPassword,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.editDialog,
                                        "randomPassword",
                                        $$v
                                      )
                                    },
                                    expression: "editDialog.randomPassword"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]),
                      _c("el-input", {
                        attrs: {
                          no: "password",
                          type: "password",
                          disabled: _vm.editDialog.passDisabled
                        },
                        model: {
                          value: _vm.editDialog.form.password,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "password", $$v)
                          },
                          expression: "editDialog.form.password"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isTP,
                          expression: "isTP"
                        }
                      ],
                      attrs: { label: _vm.$t("CargoMsg.Cargo_BookingAgent") }
                    },
                    [
                      _c("cargo-owned-branch-select", {
                        staticStyle: { width: "380px" },
                        attrs: {
                          value: _vm.toNumArray(
                            _vm.editDialog.form.bookingAgentBranchIds
                          ),
                          no: "multipleBranchId",
                          "select-type":
                            _vm.selectTypeNames.basic_data_Office_All,
                          "static-options": _vm.branchCompanyHierarchy
                            ? _vm.currentOfficeList
                            : null,
                          multiple: true,
                          clearable: "",
                          placeholder: _vm.$t(
                            "SystemMaintenance.PleaseSelectBookingAgent"
                          )
                        },
                        on: {
                          input: function(val) {
                            _vm.editDialog.form.bookingAgentBranchIds = _vm.toTxt(
                              val
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.hasNewB2B
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              staticClass: "companyTypeClass",
                              model: {
                                value: _vm.editDialog.form.companyTypes,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.editDialog.form,
                                    "companyTypes",
                                    $$v
                                  )
                                },
                                expression: "editDialog.form.companyTypes"
                              }
                            },
                            [
                              _c(
                                "el-checkbox",
                                { attrs: { label: 0, disabled: "" } },
                                [_vm._v(_vm._s(_vm.$t("Partners.isCustomer")))]
                              ),
                              _c("el-checkbox", { attrs: { label: 1 } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("Partners.isDesignationAgent"))
                                )
                              ]),
                              _c("el-checkbox", { attrs: { label: 2 } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_DestinationAgent")
                                  )
                                )
                              ]),
                              _c("el-checkbox", { attrs: { label: 3 } }, [
                                _vm._v(_vm._s(_vm.$t("SeaExport.Consignee")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "ok", type: "primary" },
                  on: { click: _vm.save }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.modifyBookingAgentDialog.visible,
            title: _vm.$t("Partners.modificationOfBookingAgents"),
            width: "500px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.modifyBookingAgentDialog, "visible", $event)
            },
            close: _vm.closeModifyBookingAgentDialog
          }
        },
        [
          _c(
            "div",
            { staticClass: "app-main-inner-row modify-booking-agent" },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "120px", "label-position": "top" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_BookingAgent"),
                        required: ""
                      }
                    },
                    [
                      _c("cargo-owned-branch-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          value: _vm.toNumArray(
                            _vm.modifyBookingAgentDialog.form
                              .bookingAgentBranchIds
                          ),
                          no: "bookingAgentBranchIds",
                          "select-type":
                            _vm.selectTypeNames.basic_data_Office_All,
                          "static-options": _vm.branchCompanyHierarchy
                            ? _vm.currentOfficeList
                            : null,
                          multiple: true,
                          clearable: "",
                          placeholder: _vm.$t(
                            "SystemMaintenance.PleaseSelectBookingAgent"
                          )
                        },
                        on: {
                          input: function(val) {
                            _vm.modifyBookingAgentDialog.form.bookingAgentBranchIds = _vm.toTxt(
                              val
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "confirmModify", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.confirmModifyBookingAgent()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancelModify" },
                  on: {
                    click: function($event) {
                      _vm.modifyBookingAgentDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }